import React, { useState } from 'react';
import axios from 'axios';
import styles from './Reset_PW.module.css'; // CSS 모듈

import HeaderSection from '../all_pages/HeaderSection';  // HeaderSection 컴포넌트 불러오기

import checkoutimg from '../../assets/mypage/checkout.svg'; // 로고 이미지 import

import { useNavigate } from 'react-router-dom';

const ResetPW = () => {
const [step, setStep] = useState(1); // 1: 비밀번호 검증, 2: 새 비밀번호 설정
const [currentPassword, setCurrentPassword] = useState(''); // 입력된 비밀번호 가져오기
const [newPassword, setNewPassword] = useState(''); // 이게 왜 필요하지
const [message, setMessage] = useState(''); // 메세지

const [isPasswordVerified, setIsPasswordVerified] = useState(false);
const [isVerifyDisabled, setIsVerifyDisabled] = useState(false); // 확인 버튼 비활성화 상태


const [confirmPassword, setConfirmPassword] = useState(''); // 새로운 비밀번호 확인


const apiUrl = process.env.REACT_APP_API_URL;

const navigate = useNavigate(); // navigate 정의
const nextStep = () => setStep(step + 1);
const prevStep = () => setStep(step - 1);

// 비밀번호 검증 핸들러
const handleVerifyPassword = async () => {
    setMessage(''); // 이전 메시지 초기화
    try {
    const response = await axios.post(
        `${apiUrl}/accounts/verify_password/`,
        { password: currentPassword },
        {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },  
        }
    );

    if (response.status === 200) {
        // setStep(2); // 다음 단계로 이동
        setIsPasswordVerified(true); // 비밀번호 확인 상태 업데이트
        setMessage('비밀번호 검증 성공!');
        setIsVerifyDisabled(true); // 확인 버튼 비활성화
    }
    } catch (error) {
        if (error.response?.status === 401) {
            // 401 Unauthorized 처리
            alert('올바른 접근이 아닙니다.');
            navigate('/login'); // 로그인 페이지로 리디렉션
        } else {
            // 다른 오류 처리
            const errorMessage =
                error.response?.data?.error || '비밀번호가 맞지 않아요. 다시 확인해주세요!';
            setMessage(errorMessage); // 오류 메시지 표시
        }
        setIsPasswordVerified(false); // 비밀번호 확인 실패 시 상태 초기화
        setIsVerifyDisabled(false); // 확인 버튼 다시 활성화
    }
};

// 새로운 비밀번호 설정 핸들러
const handleSetNewPassword = async () => {
    setMessage(''); // 이전 메시지 초기화
    try {
    const response = await axios.post(
        `${apiUrl}/accounts/set_password/`,
        { new_password: newPassword },
        {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        }
    );

    if (response.status === 200) {
        setMessage('비밀번호가 성공적으로 변경되었습니다!');
        nextStep()
        setCurrentPassword(''); // 이전 비밀번호 초기화
        setNewPassword(''); // 새 비밀번호 초기화
    }
    } catch (error) {
        if (error.response?.status === 401) {
        // 401 Unauthorized 처리
        alert('올바른 접근이 아닙니다.');
        navigate('/login'); // 로그인 페이지로 리디렉션
        } else {
        const errorMessage =
            error.response?.data?.error || '비밀번호 변경 실패. 다시 시도해주세요.';
        setMessage(errorMessage); // 오류 메시지 표시
        }
    }
};


//// 비밀번호 검증
const validatepassword = (password) => {
    const isLengthValid = password.length >= 8; // 최소 8자 이상
    const isNoSpace = !/\s/.test(password); // 공백 허용하지 않음
    const isNoKorean = !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(password); // 한글 허용하지 않음
    const hasSpecialChar = /^[a-zA-Z0-9!@$%]+$/.test(password) && /[!@$%]/.test(password); // !@$%만 허용

    return isLengthValid && hasSpecialChar && isNoSpace && isNoKorean;
};
///////////////////////////////////////////////////////////////////////////////// 비밀번호 검증 끝

//// 로그아웃
const handleLogout = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    const accessToken = localStorage.getItem('accessToken');

    try {
    await axios.post(
        `${process.env.REACT_APP_API_URL}/accounts/logout/`,
        { refresh: refreshToken },
        {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
        }
    );

    // 로그아웃 성공 시 토큰 및 사용자 정보 제거
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('username');
    navigate('/login');
    } catch (error) {
    console.error('로그아웃 실패:', error);

    // 에러 발생 시 메시지 출력 및 로그인 페이지로 리디렉션
    alert('정상적인 접근이 아닙니다.');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('username');
    navigate('/login');
    }
};
///////////////////////////////////////////////////////////////////////////////// 로그아웃 끝


return (
    <div className={styles.pageContainer}>
    {step === 1 && (
        <div className={styles.step}>
            <HeaderSection 
                title="비밀번호 재설정" 
                onBack={() => navigate('/mypage')} 
                // onCancel={() => navigate('/login')} 
            />    
            <p className={styles.headers_text}>비밀번호 재설정을 위해<br/> 기존 비밀번호를 입력해주세요</p>
            <div className={styles.signupInputContainer}>
                <label className={styles.signupLabel}>기존 비밀번호</label>
                <div className={styles.inputWithButton}>
                    <input 
                        type="password"
                        placeholder="현재 비밀번호"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        className={styles.input}
                        disabled={isPasswordVerified} // 비밀번호 확인 완료 시 비활성화
                    />


                    {/* 아이디 중복 버튼 */}
                    <button
                        className={styles.checkButton}
                        onClick={handleVerifyPassword} // 닉네임 중복 체크 버튼 클릭 시 실행
                        disabled={isPasswordVerified || currentPassword.trim() === ''}
                        // disabled={loginIdLoading || !validateLoginID(loginId)|| isLoginidAvailable} // 중복 체크 중이거나 닉네임 유효성 체크 실패 시 비활성화
                    >
                    확인
                    </button>
                </div>
                </div>

                {message && (
                    <p
                        className={
                        isPasswordVerified ? styles.successMessage : styles.errorMessage
                        }
                    >
                        {message}
                    </p>
                )}

            {/* 하단 고정 버튼 */}
            <div className={styles.nextButtonContainer}>
                <button 
                className={styles.nextButton} 
                onClick={nextStep}
                disabled={!isPasswordVerified} // 비밀번호 확인이 완료되기 전까지 비활성화
                >
                다음으로
            </button>
            </div>
        </div>
    )}
    {step === 2 && (
        <div className={styles.step}>

            <HeaderSection 
                title="비밀번호 재설정" 
                onBack={prevStep}
                // onCancel={() => navigate('/login')} 
            />  

        <p className={styles.headers_text2}>새로운 비밀번호를 입력해주세요</p>
        <p className={styles.middle_text}>영문, 특수기호(!@$%) 조합 8자 이상</p>
        
        {/* 새로운 비밀번호 입력 */}
        <div className={styles.signupInputContainer}>
        <label className={styles.signupLabel}>새로운 비밀번호</label>
        <input
            type="password"
            placeholder="새로운 비밀번호"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className={styles.input}
        />
        <p className={styles.message}>
            {newPassword && !validatepassword(newPassword) && '비밀번호 규칙에 맞지 않습니다.'}
        </p>
        </div>

        {/* 새로운 비밀번호 확인 입력 */}
        <div className={styles.signupInputContainer}>
        <label className={styles.signupLabel}>새로운 비밀번호 확인</label>
        <input
            type="password"
            placeholder="새로운 비밀번호 확인"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className={styles.input}
        />
        <p className={styles.message}>
            {confirmPassword && confirmPassword !== newPassword && '비밀번호가 일치하지 않습니다.'}
        </p>
        </div>

            {/* 하단 고정 버튼 */}
            <div className={styles.nextButtonContainer}>
                <button 
                className={styles.nextButton} 
                onClick={handleSetNewPassword}
                disabled={
                    !validatepassword(newPassword) || // 새로운 비밀번호 규칙 검증
                    confirmPassword !== newPassword || // 비밀번호 확인 일치 여부
                    !newPassword.trim() || // 공백 확인
                    !confirmPassword.trim() // 공백 확인
                }
                >
                확인하기
            </button>
            </div>



        </div>
    )}
        {step === 3 && (
            <div className={styles.step}>

            <HeaderSection 
                title="비밀번호 재설정" 
                // onBack={prevStep}
                // onCancel={() => navigate('/login')} 
            />  

            <p className={styles.headers_text}>비밀번호 재설정이 <br/> 완료되었습니다.</p>

            {/* 이미지 추가 */}
            <div className={styles.imageContainer}>
                <img 
                    src={checkoutimg} 
                    alt="비밀번호 재설정 완료" 
                    className={styles.checkoutImage} 
                />
            </div>


            {/* 하단 고정 버튼 */}
            <div className={styles.nextButtonContainer}>
                <button 
                className={styles.nextButton} 
                onClick={handleLogout}
                disabled={!isPasswordVerified} // 비밀번호 확인이 완료되기 전까지 비활성화
                >
                로그인하기
            </button>
            </div>


            </div>
        )}
    </div>
);
};

export default ResetPW;
